import { ByClassesData } from './data-api-by-classes.type'
import { ByCustomersAndFundsData } from './data-api-by-customers-and-funds.type'
import { ByFundsData } from './data-api-by-funds.type'
import { ByComplexesAndAllowancesData } from './data-api-by-complexes-and-allowances.type'

export type AnyAvailableType =
  | ByClassesData
  | ByFundsData
  | ByCustomersAndFundsData
  | ByComplexesAndAllowancesData

export const isByClassesData = (data: AnyAvailableType): data is ByClassesData => {
  return 'summary' in data && 'details' in data
}

export const isByFundsData = (data: AnyAvailableType): data is ByFundsData => {
  return 'details_group' in data && data.details_group === 'by_funds'
}

export const isByCustomersAndFundsData = (
  data: AnyAvailableType,
): data is ByCustomersAndFundsData => {
  return 'details_group' in data && data.details_group === 'by_customers_and_funds'
}

export const isByComplexesAndAllowancesData = (
  data: AnyAvailableType,
): data is ByComplexesAndAllowancesData => {
  return 'details_group' in data && data.details_group === 'by_complexes_and_allowances'
}
